import { render, staticRenderFns } from "./FeeConfigurationSetup.vue?vue&type=template&id=aa976760&"
import script from "./FeeConfigurationSetup.vue?vue&type=script&lang=js&"
export * from "./FeeConfigurationSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports